<template>
  <div class="app-container">
    <!--工具栏-->
    <!--表单组件-->
    <eForm ref="form" :is-add="isAdd" />
    <!--表格渲染-->

    <!-- 表格1 start -->
    <el-table
      v-if="tableIndex === 1"
      v-loading="loading"
      :data="data"
      size="small"
      style="width: 100%"
    >
      <el-table-column prop="num" label="序号" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 + page * size }}
        </template>
      </el-table-column>
      <el-table-column prop="speciesId" label="种类" align="center">
        <template slot-scope="scope">
          {{ getOption(scope.row.speciesId, options1, "speciesName", "id") }}
        </template>
      </el-table-column>
      <el-table-column prop="subjectId" label="科目" align="center">
        <template slot-scope="scope">
          {{
            getOption(scope.row.subjectId, options3, "subjectName", "subjectId")
          }}
        </template>
      </el-table-column>
      <el-table-column prop="issue" label="问题" align="center" />
      <el-table-column prop="topicId" label="话题" align="center">
        <template slot-scope="scope">
          {{ getOption(scope.row.topicId, options2, "topicName", "id") }}
          <!-- {{scope.row.topicId}} -->
        </template>
      </el-table-column>

      <el-table-column prop="step1Result" label="step1答案" align="center" />
      <el-table-column prop="step1Music" label="step1音频" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.step1Music"
            target="_blank"
            :href="scope.row.step1Music"
            type="primary"
            >{{ scope.row.step1Music }}</el-link
          >
        </template>
      </el-table-column>

      <el-table-column prop="step2Result" label="step2答案" align="center" />
      <el-table-column prop="step2Music" label="step2音频" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.step2Music"
            target="_blank"
            :href="scope.row.step2Music"
            type="primary"
            >{{ scope.row.step2Music }}</el-link
          >
        </template>
      </el-table-column>

      <el-table-column prop="step3Result" label="step3答案" align="center" />
      <el-table-column prop="step3Music" label="step3音频" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.step3Music"
            target="_blank"
            :href="scope.row.step3Music"
            type="primary"
            >{{ scope.row.step3Music }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        v-if="selectFlag === false"
        width="150px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          />
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id].doClose()"
              >
                取消
              </el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
                >确定
              </el-button>
            </div>
            <el-button
              slot="reference"
              type="danger"
              icon="el-icon-delete"
              size="mini"
            />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectFlag === true"
        label="操作"
        width="150px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            @click="changeAdd(scope.row.id)"
            v-if="selectActive(scope.row.id, num) === false"
            size="mini"
            type="primary"
            >选择</el-button
          >
          <el-button
            @click="changeDel(scope.row.id)"
            v-if="selectActive(scope.row.id, num) === true"
            size="mini"
            type="danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格1 end -->

    <!-- 表格2 start -->
    <el-table
      v-if="tableIndex === 2"
      v-loading="loading"
      :data="data"
      size="small"
      style="width: 100%"
    >
    </el-table>
    <!-- 表格2 end -->
    <!--分页组件-->
    <el-pagination
      :total="total"
      :current-page="page + 1"
      style="margin-top: 8px"
      layout="total, prev, pager, next, sizes"
      @size-change="sizeChange"
      @current-change="pageChange"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import initData from "@/mixins/initData";
import { delTable } from "@/api/table";
import { parseTime } from "@/utils/index";
import eForm from "./form";

export default {
  components: { eForm },
  mixins: [initData],
  props: {
    selectFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectFlag: false,
      selectArr: {},
      num: 0,
      delLoading: false,
      tableIndex: 1,
      speciesId: "",
      subjectId: "",
      // options: [],
      options1: [],
      options2: [],
      options3: [],
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    checkPermission,
    changeAdd(e) {
      this.selectArr[e] = true;
      this.num++;
      this.$emit("selectOver", this.selectArr);
    },
    changeDel(e) {
      this.num--;
      delete this.selectArr[e];
      this.$emit("selectOver", this.selectArr);
    },
    selectActive(id) {
      return this.selectArr[id] === true ? true : false;
    },
    beforeInit() {
      this.url = "api/table/" + this.tableIndex;
      this.data = [];

      const sort = "id,desc";
      this.params = { page: this.page, size: this.size, sort: sort };
      if (this.speciesId || this.speciesId === 0) {
        this.params["speciesId"] = this.speciesId;
      }
      if (this.subjectId || this.subjectId === 0) {
        this.params["subjectId"] = this.subjectId;
      }
      return true;
    },
    subDelete(id) {
      this.delLoading = true;
      delTable(this.tableIndex, id)
        .then((res) => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleChangePage();
          this.init();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500,
          });
        })
        .catch((err) => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err.response.data.message);
        });
    },
    add() {
      this.isAdd = true;
      this.$refs.form.dialog = true;
      this.$refs.form.options1 = this.options1;
      this.$refs.form.options2 = this.options2;
      this.$refs.form.options3 = this.options3;
      this.$refs.form.tableIndex = this.tableIndex;
    },
    edit(data) {
      this.isAdd = false;
      const _this = this.$refs.form;
      _this.form = {
        id: data.id,
        // 种类id
        speciesId: data.speciesId,
        // 科目名称
        subjectId: data.subjectId,
        // 问题
        issue: data.issue,
        // step1答案
        step1Result: data.step1Result,
        // step1音频
        step1Music: data.step1Music,
        // step2答案
        step2Result: data.step2Result,
        // step2音频
        step2Music: data.step2Music,
        // step3答案
        step3Result: data.step3Result,
        // step3音频
        step3Music: data.step3Music,
        // 话题
        topicId: data.topicId,
      };
      _this.options1 = this.options1;
      _this.options2 = this.options2;
      _this.options3 = this.options3;
      _this.tableIndex = this.tableIndex;
      _this.dialog = true;
    },
    getOption(id, option, name, sid) {
      if (!option && option.length === 0) return "";
      for (let i in option) {
        if (+option[i][sid] === +id) {
          return option[i][name];
        }
      }
    },
  },
  beforeMount() {},
};
</script>

<style scoped>
</style>
